import React from "react";
import Icon from "../../../../../../components/Icon";
import { clsx } from "clsx";

type Props = {
  onClick: () => undefined | void;
  disabled: boolean;
};

export const PrevButton: React.FC<Props> = ({ onClick, disabled }) => (
  <div
    data-testid="screenshots-carousel-btn-prev"
    className="cursor-pointer embla__button_left"
    onClick={onClick}
  >
    <Icon
      className={clsx(
        `cursor-pointer ${disabled && "embla__chevron_disabled"}`
      )}
      name="chevron-right"
    />
  </div>
);

export const NextButton: React.FC<Props> = ({ onClick, disabled }) => (
  <div
    data-testid="screenshots-carousel-btn-next"
    className="cursor-pointer embla__button_right"
    onClick={onClick}
  >
    <Icon
      className={clsx(
        `cursor-pointer ${disabled && "embla__chevron_disabled"}`
      )}
      name="chevron-right"
    />
  </div>
);
